/** Clases reutilizables en el panel admin (fondo blanco). */

export const ADMIN_INPUT_CLASS =
  'w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none placeholder:text-slate-400 focus:border-brand-green focus:ring-1 focus:ring-brand-green/40';

export const ADMIN_ICON_BTN_CLASS =
  'rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-900';

export const ADMIN_DELETE_BTN_CLASS =
  'rounded-lg p-2 text-red-600 transition hover:bg-red-50 hover:text-red-700';

const PUBLISHED = 'bg-emerald-50 text-emerald-800 ring-emerald-200';
const DRAFT = 'bg-slate-100 text-slate-600 ring-slate-200';

/** Badge publicado / borrador en tablas. */
export function adminPublishStatusClasses(active) {
  return `rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ring-1 ring-inset ${
    active ? PUBLISHED : DRAFT
  }`;
}
